import React, { FC } from 'react';
import * as ModalStyles from './_modal.module.scss';
import { IoClose } from 'react-icons/io5';
import Text from '../Text';

type ModalProps = {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children?: React.ReactNode;
    timer?: React.ReactNode;
    testId?: string;
}

const Modal: FC<ModalProps> = ({
    isOpen,
    onClose,
    title,
    children,
    timer,
    testId,
}) => {
    if (!isOpen) return null;

    return (
        <div className={ModalStyles.body}>
            <div className={ModalStyles.container}>
                <div className={ModalStyles.header}>
                    <Text
                        label={title}
                        className={ModalStyles.title} isBold
                    />

                    <div className={ModalStyles['container-with-timer']}>
                        {timer}

                        <button
                            className={ModalStyles['close-button']}
                            onClick={onClose}
                            aria-label='Close modal'
                            data-testid={testId}
                        >
                            <IoClose size={30} />
                        </button>
                    </div>
                </div>

                <div className={ModalStyles.content}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;
